import ConfirmBrowserRefresh from './confirm-browser-refresh'
import HubSpotUtk from './hubspot-utk.js'
import { PhoneNumberMask } from './input-masks.js'
import ScrollToTopOnClick from './scroll-top'
import StickyCta from './sticky-cta'

export const Hooks = {
  ConfirmBrowserRefresh,
  HubSpotUtk,
  PhoneNumberMask,
  ScrollToTopOnClick,
  StickyCta,
}
